import script from "./DriftingParticleBall.vue?vue&type=script&setup=true&lang=js"
export * from "./DriftingParticleBall.vue?vue&type=script&setup=true&lang=js"

import "./DriftingParticleBall.vue?vue&type=style&index=0&id=8bf0a652&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8bf0a652"]])

export default __exports__